export default "__VITE_ASSET__C$AwLqGm__"